import { atomicMarket } from "../dal/atomic-market";
import { derived, writable } from "svelte/store";
import { getRPlanetPrice } from "./currencies";
import { userStore } from "./user";
import { RPLANET_COLLECTION } from "./asset-staking";
export var LAND_TYPE;
(function (LAND_TYPE) {
    LAND_TYPE["CAPONIUM"] = "Caponium";
    LAND_TYPE["ENEFTERIUM"] = "Enefterium";
    LAND_TYPE["WAXON"] = "Waxon";
    LAND_TYPE["WECANITE"] = "Wecanite";
})(LAND_TYPE || (LAND_TYPE = {}));
export const landsIncomeStore = writable(0.0);
export const accountAssets = derived(userStore, ($userStore, set) => {
    atomicMarket()
        .getAssets({
        owner: $userStore.account,
        collection_name: RPLANET_COLLECTION,
    })
        .then((assets) => set(assets || []));
}, []);
export const accountLands = derived(userStore, ($userStore, set) => {
    atomicMarket()
        .getAssets({
        owner: $userStore.account,
        collection_name: RPLANET_COLLECTION,
    }, 0, 500)
        .then((assets) => {
        landsIncomeStore.set(0.0);
        assets = assets.filter((asset) => asset.schema.schema_name.includes("land"));
        set(assets || []);
    });
}, []);
export function getLandsYield(lands) {
    const landYield = {};
    lands.forEach((land) => {
        var _a, _b, _c;
        const mineral = (_b = (_a = land.data) === null || _a === void 0 ? void 0 : _a.name) === null || _b === void 0 ? void 0 : _b.toUpperCase();
        const amount = (_c = land.data) === null || _c === void 0 ? void 0 : _c.base_rate;
        if (!landYield[mineral]) {
            landYield[mineral] = 0;
        }
        landYield[mineral] += amount;
    });
    return Object.entries(landYield).map(([id, value]) => ({
        id,
        value,
    }));
}
export function getLandsYieldPrices(landsYield, rplanetPrices, waxPrice) {
    const aetherPrice = getRPlanetPrice(rplanetPrices, "AETHER");
    return landsYield.map(({ id, value }) => {
        const priceInWax = getRPlanetPrice(rplanetPrices, id);
        const wax = value * priceInWax;
        const aeth = wax / aetherPrice;
        const usd = wax * waxPrice;
        return {
            id,
            value,
            wax,
            aeth,
            usd,
        };
    });
}
export function aggregateLandYields(landsYield) {
    let totalWax = 0;
    let totalAeth = 0;
    let totalUSD = 0;
    landsYield.forEach(({ aeth, wax, usd }) => {
        totalAeth += aeth;
        totalWax += wax;
        totalUSD += usd;
    });
    landsIncomeStore.set(totalUSD);
    return {
        wax: totalWax,
        aeth: totalAeth,
        usd: totalUSD,
    };
}
